var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.value,"color":"white"}},[_c('v-img',{attrs:{"src":"/images/Iphone-spinner-2.gif","alt":"Loading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }